import { Divider, TableRow, TableCell, Typography } from '@mui/material';
import { Grid2 } from '@mui/material';
import { navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { PATIENTS } from '@constants/routes';

import { useCuration } from '@hooks/useCuration';

const messages = defineMessages({
  'column.lastAlertDate': {
    id: 'patientAlertTable.column.lastAlertDate',
    defaultMessage: 'Last Alert Date',
  },
  'column.openAlertCount': {
    id: 'patientAlertTable.column.openAlertCount',
    defaultMessage: 'Number Of Open Alerts',
  },
});

interface AlertedPatientMobileRowProps {
  data: (string | React.ReactNode)[];
  dataIndex: number;
  total: number;
}
export default function AlertedPatientMobileRow({
  data,
  dataIndex,
  total,
}: AlertedPatientMobileRowProps) {
  const { formatMessage } = useIntl();
  const { viewAsPatient } = useCuration();

  const [name, dob, open_alert_count, last_alert_date, user_id, icon_button] =
    data;

  const handleClick = () => {
    if (typeof user_id === 'string') {
      viewAsPatient(user_id);
      navigate(`${PATIENTS}${user_id}`);
    }
  };

  return (
    <>
      <TableRow
        sx={({ palette: { grey } }) => ({
          height: 'auto',
          ':hover': {
            cursor: typeof user_id === 'string' ? 'pointer' : undefined,
            backgroundColor: grey.A100,
          },
        })}
        onClick={handleClick}
      >
        <TableCell>
          <Grid2 container>
            <Grid2 size={{ xs: 6 }}>
              <Typography> {name}</Typography>
            </Grid2>
            <Grid2 size={{ xs: 6 }} textAlign="right">
              <Typography> {dob}</Typography>
            </Grid2>

            <Grid2 size={{ xs: 11 }}>
              <Typography color="text.secondary" variant="body2">
                {formatMessage(messages['column.openAlertCount'])}:{' '}
                {open_alert_count}
              </Typography>
              <Typography color="text.secondary" variant="body2">
                {formatMessage(messages['column.lastAlertDate'])}:{' '}
                {last_alert_date}
              </Typography>
            </Grid2>
            <Grid2
              size={{ xs: 1 }}
              sx={{
                display: 'flex',
                alignItems: 'flex-end',
                flexDirection: 'row-reverse',
              }}
            >
              {icon_button}
            </Grid2>
          </Grid2>
        </TableCell>
      </TableRow>
      {dataIndex + 1 !== total && <Divider />}
    </>
  );
}
